<template>
    <v-container transparent>
        <v-layout>
            <v-card width="100%" flat>
                <v-container class="pa-5">
                    <v-flex lg12 md12 xs12>
                        <v-card-title primary-title class="py-4 title">
                            Помощь по работе с кабинетом
                        </v-card-title>
                        <v-card-text>
                            <pre>
1. Форма регистрации // авторизации
2. Личный профиль и настройки акаунта (информация о себе, загрузка фото)
3. Регистрация теста/кита
4. Поиск по кабинету
5. Форма загрузки/выгрузки файлов (индикатор загрузки)
6. Страница с отчетами и возможность покупки: диета, спорт, фитнес
7. Раздел с опросниками/анкетами
8. Покупка кита для сдачи и тип анализа: низкоплотный геном, экзом, полный геном
9. Раздел с результатами анализа, выдача по отчетам (картинки + текст)
10. Настройка совместного доступа к данным/отчетам для врачей
11. Панель управления - сверху и слева (разделы, навигация).

Формы:
1. Форма личной информации
*Имя
*Фамилия
*Отчество (опционально)
*День Рождения
*Почта
*Телефон
*Страна
*Город
2. Форма адреса доставки
Адрес доставки
Страна (выпадающий список)
Область район (выпадающий список)
Город:
Почтовый индекс:
Почтовый адрес:
Телефон для связи:
Электронная почта для отправки чеков:
Способ коммуникации: позвонить/написать смс/ написать в мессенджер
Checkbox  Настоящим подтверждаю, что я ознакомлен и согласен с условиями
политики конфиденциальности.
3. Форма базовой анкеты для проведения секвенирования/получения ген теста
Для предоставления более объективной информации рекомендуется правдиво и точно
ответить на предлагаемые вопросы нашей анкеты. Все сведения, которые
Вы предоставляете, останутся строго конфиденциальными.
*Укажите Ваш пол
*Укажите Ваш рост (см)
*Укажите Ваш вес (кг)
*Количество полных лет (года)
*Семейное положение (женат/замужем/холост)
*Наличие детей (да/нет)
*Место рождения (Страна/город)
*Как Вы оцениваете свое здоровье (по шкале от 1 до 10, 1 - плохое, 10 - очень хорошее).
*Как часто Вы проходите медицинское обследование? (очень редко, один раз в год, чаще чем в раз в год)
*Укажите, к какой расе/этнической группе Вы принадлежите (выпадающий список: европейская (европеоид),
африканская (негроид), азиатская (монголоид), латиноамериканская, евреи-ашкенази)
*Национальность: вписать/ указать “не знаю”.
*Обнаруживались ли у Вас следующие состояния?
□ Повышенный уровень холестерина в крови
□ Высокое артериальное давление
□ Нарушение сердечного ритма или работы сердца
□ Увеличенная частота сердечных сокращений в покое
□ Повышенный уровень  глюкозы в крови
□ Избыточная масса тела
□ Недостаточная масса тела

                            </pre>

                        </v-card-text>

                    </v-flex>
                </v-container>

            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "TestFileDownload",
        data: () => ({
            testRegFormValid: false,
            testRegFormIsDirty: false,
            testReg: {
                key: "",
                formatted: ""
            },
            utility: {},
            rules: {
                required: value => !!value || 'Required.',
                counter: value => value.length <= 20 || 'Max 20 characters'
            }
        }),
        watch: {
            'testReg.key': {
                handler: function (val) {
                    this.testReg.formatted = val.slice(0, 6) + '-' + val.slice(6)
                }
            }
        },
        methods: {
            downloadFile: function () {
            },
        },
        computed: {
            profileFormCanSave: function () {
                if (this.profileFormValid && this.isProfileFormIsDirty) return true;
                return false;
            }
        }/*,
        created: function () {
        }*/

    }
</script>

<style type="scss" scoped>
    .v-text-field-email {
        input {
            color: red;
        }
    }
</style>